import { render } from "./ParticlesBG.vue?vue&type=template&id=7ff8e863&scoped=true"
import script from "./ParticlesBG.vue?vue&type=script&lang=js"
export * from "./ParticlesBG.vue?vue&type=script&lang=js"

import "./ParticlesBG.vue?vue&type=style&index=0&id=7ff8e863&lang=css"
import "./ParticlesBG.vue?vue&type=style&index=1&id=7ff8e863&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ff8e863"]])

export default __exports__